import { render, staticRenderFns } from "./talk_fushen.vue?vue&type=template&id=6409c2a0&scoped=true&"
import script from "./talk_fushen.vue?vue&type=script&lang=js&"
export * from "./talk_fushen.vue?vue&type=script&lang=js&"
import style0 from "./talk_fushen.vue?vue&type=style&index=0&id=6409c2a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6409c2a0",
  null
  
)

export default component.exports